<template>
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_168_8908)">
      <path
        d="M10.0002 3.3132C9.01996 3.3132 8.12348 3.40225 7.31542 3.57648L4.87017 1.96555C3.91177 1.33416 2.6063 1.99245 2.60979 3.10535L2.62253 7.16746C2.31574 7.93833 2.1582 8.81734 2.1582 9.79768C2.1582 13.9478 4.98133 16.2822 10.0002 16.2822C15.0191 16.2822 17.8422 13.9478 17.8422 9.79768C17.8422 8.8172 17.6847 7.93808 17.3778 7.16713L17.3904 3.10535C17.394 1.99245 16.0886 1.33416 15.1301 1.96555L12.6849 3.57646C11.8769 3.40224 10.9804 3.3132 10.0002 3.3132Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.46191 15.4694C5.64114 14.963 6.21568 14.6915 6.74519 14.8629C7.64385 15.1537 8.72776 15.314 9.99935 15.314C11.2709 15.314 12.3548 15.1537 13.2536 14.8629C13.783 14.6915 14.3576 14.963 14.5368 15.4694C14.716 15.9756 14.432 16.5251 13.9026 16.6964C12.7533 17.0684 11.4432 17.2498 9.99935 17.2498C8.55549 17.2498 7.24532 17.0684 6.09615 16.6964C5.56664 16.5251 5.28269 15.9756 5.46191 15.4694Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.29598 2.76247C4.01024 2.57423 3.621 2.77049 3.62203 3.10231L3.63478 7.16443C3.63646 7.69898 3.18465 8.13363 2.62562 8.13523C2.06661 8.13684 1.61208 7.70478 1.6104 7.17023L1.59767 3.10812C1.59172 1.21412 3.81343 0.0938227 5.44448 1.16835L7.53542 2.54586C8.30357 2.41149 9.12702 2.34515 10.0003 2.34515C10.8735 2.34515 11.6969 2.41148 12.465 2.54584L14.5559 1.16835C16.187 0.0938227 18.4087 1.21412 18.4028 3.10812L18.39 7.1699C18.3883 7.70445 17.9338 8.1365 17.3748 8.1349C16.8158 8.1333 16.364 7.69865 16.3657 7.1641L16.3783 3.10231C16.3794 2.77049 15.9902 2.57423 15.7044 2.76247L13.2592 4.37339C13.0267 4.52658 12.7378 4.57992 12.4623 4.52052C11.738 4.36436 10.9174 4.28097 10.0003 4.28097C9.08315 4.28097 8.26246 4.36437 7.53814 4.52055C7.26267 4.57994 6.97378 4.5266 6.74125 4.37341L4.29598 2.76247Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.0253906 10.3058C0.0253906 9.77124 0.478564 9.33789 1.03758 9.33789H4.86241C5.42143 9.33789 5.8746 9.77124 5.8746 10.3058C5.8746 10.8404 5.42143 11.2737 4.86241 11.2737H1.03758C0.478564 11.2737 0.0253906 10.8404 0.0253906 10.3058Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.31361 15.4643C1.00601 15.018 1.13505 14.4177 1.60183 14.1234L4.79556 12.111C5.26235 11.8169 5.8901 11.9402 6.1977 12.3866C6.5053 12.8329 6.37626 13.4332 5.90948 13.7273L2.71575 15.7399C2.24897 16.034 1.62121 15.9107 1.31361 15.4643Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.9752 10.3058C19.9752 9.77124 19.5221 9.33789 18.9631 9.33789H15.1382C14.5792 9.33789 14.126 9.77124 14.126 10.3058C14.126 10.8404 14.5792 11.2737 15.1382 11.2737H18.9631C19.5221 11.2737 19.9752 10.8404 19.9752 10.3058Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.6879 15.4643C18.9955 15.018 18.8665 14.4177 18.3998 14.1234L15.206 12.111C14.7392 11.8169 14.1114 11.9402 13.8039 12.3866C13.4962 12.8329 13.6253 13.4332 14.0921 13.7273L17.2858 15.7399C17.7525 16.034 18.3803 15.9107 18.6879 15.4643Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8578 12.5799C10.3825 13.0297 9.61718 13.0297 9.14189 12.5799L8.45071 11.9259C8.30482 11.7879 8.15042 11.6073 8.03986 11.3825C7.93098 11.161 7.83086 10.8227 7.92807 10.4344C8.03921 9.99035 8.32701 9.71552 8.62902 9.55804C8.91917 9.40676 9.22177 9.36228 9.41022 9.35242C9.78069 9.33305 10.219 9.33305 10.5894 9.35242C10.7779 9.36228 11.0805 9.40676 11.3707 9.55804C11.6727 9.71552 11.9604 9.99035 12.0715 10.4344C12.1688 10.8227 12.0687 11.161 11.9598 11.3825C11.8492 11.6073 11.6949 11.7879 11.549 11.9259L10.8578 12.5799Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_168_8908">
        <rect
          width="20"
          height="17"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
